module.exports = __webpack_public_path__ + "img/eSSstep4.15813c1c.jpg";